module.exports = __webpack_public_path__ + "static/media/play.738cbde7.svg";